/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $('body').on('change', '#giftPackaging', function(){
    var is_checked = $(this).prop('checked');
    if(is_checked) {
      let formData = {
       'items': [{
        'id': 47349334212950,
        'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    } else {
      let formData = {
       'updates': {
        47349334212950: 0
        }
      };
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  });

  
  $(".scrollTop svg" ).click(function(){
    $('html, body').animate({scrollTop:0}, 'slow');
    return false;
  });


  $('.SidebarMenu__Nav .Linklist__Item div').click(function(){
    $('.SidebarMenu__Nav--secondary').css('transform', 'unset');
    $('.main-sub-submenu').removeClass('active');
    
    var old_active_menu = $('.SidebarMenu__Nav .Linklist__Item div.active');
    var old_menu = old_active_menu.attr('data-menu');
    var menu = $(this).attr('data-menu');
    console.log(menu);

    old_active_menu.removeClass('active');
    $('.main-submenu[data-submenu="' + old_menu + '"]').removeClass('active');
    
    $(this).addClass('active');
    $('.main-submenu[data-submenu="'+ menu +'"]').addClass('active');
  });

  $('.Collapsible__Button.Collapsible_Open').click(function(){
    console.log('ok');
    $('.SidebarMenu__Nav--secondary').css('transform', 'translateX(calc(-100% - 18px))');
    $(this).next().addClass('active');
  });

  $('.Collapsible__Button.Collapsible_Close').click(function(){
    $('.SidebarMenu__Nav--secondary').css('transform', 'unset');
    $(this).parent().removeClass('active');
    
  });
  
});